import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/onErrorResumeNext';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/toPromise';
import map from 'lodash/map';
import { ajax } from 'rxjs/observable/dom/ajax';
import {plugToRequest} from 'react-cookie';
import get from 'lodash/get';
import { debug } from '../../utils';
const log = debug('lego:api');

// doesn't use https to talk to other internal server in production
const API_DOMAIN = 'api.old.accessplace.org'
const API_INTERNAL_PORT = 8080
const API_URL = __CLIENT__
	? `//${API_DOMAIN}/api/v1`
	: `http://${API_DOMAIN}:${API_INTERNAL_PORT}/api/v1`
// const API_URL = ((process.env.NODE_ENV === 'development') ? 'https' : 'http') + '://dev.accessplace.org/api/v1';
// const API_URL = '//api.accessplace.org/api/v1';
const serializeParams = (params: any) => map(params, (v: any, k) => `${k}=${encodeURIComponent(v)}`).join('&');

const sendStatus = (code, reply, err) => {
    log(`${code}:`, err.message, err.stack);
    return reply.status(code).send(err);
};

const HTTP_500 = (e, reply) => {
    return sendStatus(500, reply, e);
};

const createRouteHandler = handler => (request, reply) => {
	const handled = handler(undefined, request, reply);
	plugToRequest(request, reply);
	return (handled.toPromise ? handled.toPromise() : handled)
  .then((response) => {
			if (response.json) {
				response.json()
					.then((json) =>	reply
											.status(response.status)
											.json(json)
											.end())
					.catch((err) => {
						log(err);
						reply.status(500)
							.json('Internal server Error')
							.end()
					})
						} else {
							if (response.xhr) {
								return reply.status(response.xhr.status).send(get(response, 'xhr.responseText'))
							}
							return reply
								.status(200)
								.json(response)
								.end()
						}
		})
  .catch(err => {
			log(err)
			if (err.xhr) {
				return sendStatus(err.xhr.status, reply, get(err, 'xhr.responseText'))
			}
			return HTTP_500(err, reply);
		});
};

import cookie from 'react-cookie'
const getSessionCookie = (stateOrRequest) => {
	if (stateOrRequest) {
		return stateOrRequest.headers ? stateOrRequest.headers.cookie : stateOrRequest.cookie
	}
	const sessionid = cookie.load('sessionid')
	const auth_hash = cookie.load('auth_hash')
	if (!sessionid || !auth_hash) {
		console.log(' missing auth cookie-----------')
		return ''
	}
	return 'sessionid=' + sessionid + '"'
}

const postToAPI = (url, data, Cookie) => {
    return ajax({
        url: API_URL + url,
        method: 'post',
        body: data,
      headers: { Cookie },
			crossDomain: true,
        withCredentials: true
    })
  .toPromise()
		.catch((err) => { throw(err) })
	};

import 'rxjs/add/operator/map';
function apiRequest(route, body, method='GET', stateOrRequest?) {
	//const cookie = request ? request.headers.cookie : getSessionCookie(stateOrRequest)
	const cookie = getSessionCookie(stateOrRequest)
	// console.log('----------------------------')
	// console.log({cookie})
	return ajax({
		url: `${API_URL}/${route}`,
		headers: { cookie },
		method: method,
		responseType: 'json',
	})
		.map(reply => reply.response)
		// .catch(err => {
		// 	console.error(`Error in ${route}`)
		// 	throw(err)
		// })
}

function hasAuthCookies(req, res) {
	if (req.cookies.auth_hash === 'true' && req.cookies.sessionid) return true
	res.clearCookie('sessionid', { path: '/' })
	res.clearCookie('auth_hash', { path: '/' })
	return false
}

function requireAuth(req, res, next) {
	if (hasAuthCookies(req, res)) return next()
	res.status(401).json({error: 'Not authenticated'}).end()
}

const NOT_IMPLEMENTED = () => {throw(new Error('Not implemented'))};
export { NOT_IMPLEMENTED, postToAPI, sendStatus, createRouteHandler, HTTP_500, API_URL, requireAuth, serializeParams, apiRequest };



// WEBPACK FOOTER //
// ./src/server/api/utils.ts